<template>
  <div class="container-fluid" style="overscroll-behavior:auto;padding:0;overflow-x:hidden">
    <div class="row g-1">
      <div class="col-md-4" style="height:320px">
        <SwapTable ref="SWAPTAB01" screensize="1x1" 
        :period="$store.getters.interval"
        :display="dispobj"/>
      </div>
      <div class="col-md-8" style="height:320px">
         <SwapMap ref="SWAPMAP01" mapid="10" 
         globid="102" 
         :period="$store.getters.interval"
         screensize="1x2"/>
      </div>
    </div>
    <div class="row g-1">
      <div class="col-md-4" style="height:320px">
         <SpeedoComp ref="SPEEDO0101" 
           globid="SPEEDO0101" 
           :period="$store.getters.interval"
           :swapid="current_swap" title="ProSW TPS Monitor" /> 
      </div>
      <div class="col-md-8" style="height:320px">
        <IframeArea ref="IFRAME01" globid="IFRAME01" :swapid="current_swap"/>
      </div>
    </div>
  </div>
</template>

<script>
import SwapTable from '../components/SwapTable.vue'
import SwapMap from '../components/SwapMap.vue'
import SpeedoComp from '../components/SpeedoComp.vue'
import IframeArea from '../components/IframeArea.vue'

export default {
  name: 'MainScreen',
  components: {
     SwapTable, IframeArea, SwapMap, SpeedoComp
  },
  computed : {
    controllerid() {
        return this.$store.getters.controllerid ;
    },
    current_swap() {
      return this.$store.getters.active_swap.toString() ;
    },
    swapseq() {
      let swap = this.$store.getters.getswap_byid(this.current_swap) ;
      if (! swap) return 0 ;
      return swap.seq ;	
    },
  },
  data() {
      return {
         dispobj : [ "totinc", "totout" ] 
      }
  },
  methods : {
     stop_interval() {
         let allrefs = Object.keys(this.$refs) ;
         for ( let c of allrefs ) {
           let child = this.$refs[c] ;
           if (! child) continue ;
           if (typeof child.stop_interval == "function")
              child.stop_interval();
         }
     },
     start_interval() {
         let allrefs = Object.keys(this.$refs) ;
         for ( let c of allrefs ) {
           let child = this.$refs[c] ;
           if (! child) continue ;
           if (typeof child.start_interval == "function")
              child.start_interval();
         }
     }
  }
}
</script>


